import {Injectable} from '@angular/core';
import {AbstractDecisionLoaderService} from '../abstract-decision-loader.service';

@Injectable({
    providedIn: 'root'
})
export class ArchetypeDecisionLoaderService extends AbstractDecisionLoaderService<string> {

    constructor() {
        super('archetype')
    }
}
